export default "__VITE_ASSET__CSyP6gZs__"